/** Get roles */
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_ERROR = 'GET_ROLES_ERROR';

/** Get role permission */
export const GET_ROLES_PERMISSION_SUCCESS = 'GET_ROLES_PERMISSION_SUCCESS';
export const GET_ROLES_PERMISSION_ERROR = 'GET_ROLES_PERMISSION_ERROR';